module.exports = __webpack_public_path__ + "static/media/Roboto-Black.d6a6f887.ttf";